
const EBillType =
{
  Individual: 1,
  Corporate: 2
}


export default EBillType; 
